// Neutral placeholder content, no invented persons, partners, or specific numbers.
// Real data to be provided by NANDA SÁ team.
import { l } from "@/i18n/helpers";

export const TESTIMONIALS = [];

export const PARTNERS = [];

export const IMPACT_STATS = [
 { value: 4, suffix: "", label: l("Maisons", "Houses", "Casas") },
 { value: 10, suffix: "", label: l("Trésors valorisés", "Treasures celebrated", "Tesouros valorizados") },
 { value: 8, suffix: "", label: l("Secteurs d'activité", "Sectors of activity", "Sectores de actividade") },
 { value: 2023, suffix: "", label: l("Année de fondation", "Year of foundation", "Ano de fundação") },
 { value: 3, suffix: "", label: l("Langues officielles", "Official languages", "Línguas oficiais") },
];

/* ------------------------------------------------------------------ */
/* ACTUALITÉS NANDA SÁ. Faits confirmés uniquement.                    */
/* hidden: true = brouillon, en attente de date ou de validation.      */
/* ------------------------------------------------------------------ */
export const ACTUALITES = [
 {
  slug: "lancement-cosmetiques",
  date: "2026-01-20",
  type: l("Lancement", "Launch", "Lançamento"),
  univers: "cosmetiques",
  universLabel: l("NANDA SÁ Cosmétiques", "NANDA SÁ Cosmetics", "NANDA SÁ Cosméticos"),
  title: l(
   "Lancement de la première collection NANDA SÁ Cosmétiques",
   "Launch of the first NANDA SÁ Cosmétiques collection",
   "Lançamento da primeira colecção NANDA SÁ Cosméticos"
  ),
  excerpt: l(
   "Une gamme de soins essentiels autour de quatre plantes emblématiques d'Afrique de l'Ouest.",
   "A range of essential skincare built around four emblematic West African plants.",
   "Uma gama de cuidados essenciais em torno de quatro plantas emblemáticas da África Ocidental."
  ),
  cover: "/photos/nanda-cosmetiques/chantilly-karite-avocat-amande.jpg",
  coverAlt: l(
   "Pots de la première collection cosmétique NANDA SÁ",
   "Jars from the first NANDA SÁ cosmetics collection",
   "Frascos da primeira colecção cosmética NANDA SÁ"
  ),
  seo: {
   title: l(
    "Lancement de la collection Cosmétiques NANDA SÁ | Actualités",
    "Launch of the NANDA SÁ Cosmetics collection | News",
    "Lançamento da colecção Cosméticos NANDA SÁ | Actualidades"
   ),
   description: l(
    "NANDA SÁ lance sa première collection de cosmétiques naturels : chantillys de karité, beurre fondant et savon noir, fabriqués par les équipes de la Maison, au Sénégal et en Guinée-Bissau.",
    "NANDA SÁ launches its first natural cosmetics collection: shea whipped butters, melting butter and black soap, made by the House's teams, in Senegal and Guinea-Bissau.",
    "A NANDA SÁ lança a sua primeira colecção de cosméticos naturais: chantillys de karité, manteiga fundente e sabonete preto, fabricados pelas equipas da Casa, no Senegal e na Guiné-Bissau."
   ),
   keywords: "NANDA SÁ, cosmétiques naturels, chantilly karité, savon noir, Sénégal, Guinée-Bissau, lancement",
  },
  intro: l(
   "NANDA SÁ présente sa première collection de cosmétiques naturels. Une gamme courte, construite autour du beurre de karité et de plantes emblématiques d'Afrique de l'Ouest, fabriquée par les équipes de la Maison.",
   "NANDA SÁ presents its first natural cosmetics collection. A short range, built around shea butter and emblematic West African plants, made by the House's teams.",
   "A NANDA SÁ apresenta a sua primeira colecção de cosméticos naturais. Uma gama curta, construída em torno da manteiga de karité e de plantas emblemáticas da África Ocidental, fabricada pelas equipas da Casa."
  ),
  sections: [
   { type: "h2", id: "gamme-courte", text: l("Une gamme courte, des formules lisibles", "A short range, readable formulas", "Uma gama curta, fórmulas legíveis") },
   { type: "p", text: l(
    "La collection réunit des soins fouettés autour du beurre de karité, un beurre corporel fondant et un savon noir artisanal. Chaque fiche indique ses ingrédients, sans allégation superflue : beurre de karité, huile de baobab, hibiscus, huile d'avocat, huile d'amande douce. Les pots sont réutilisables et les étiquettes trilingues.",
    "The collection brings together whipped cares around shea butter, a melting body butter and an artisanal black soap. Each sheet lists its ingredients, with no superfluous claims: shea butter, baobab oil, hibiscus, avocado oil, sweet almond oil. Jars are reusable and labels trilingual.",
    "A colecção reúne cuidados batidos em torno da manteiga de karité, uma manteiga corporal fundente e um sabonete preto artesanal. Cada ficha indica os seus ingredientes, sem alegações supérfluas: manteiga de karité, óleo de baobá, hibisco, óleo de abacate, óleo de amêndoa doce. Os frascos são reutilizáveis e as etiquetas trilingues."
   ) },
   { type: "h2", id: "fabrication-locale", text: l("Fabriqués par les équipes de la Maison", "Made by the House's teams", "Fabricados pelas equipas da Casa") },
   { type: "p", text: l(
    "NANDA SÁ est présente au Sénégal et en Guinée-Bissau. Les soins sont fabriqués par nos équipes, avec des ingrédients récoltés en Afrique de l'Ouest auprès de coopératives partenaires. La transformation locale est au cœur de la démarche.",
    "NANDA SÁ is present in Senegal and Guinea-Bissau. The care products are made by our teams, with ingredients harvested in West Africa from partner cooperatives. Local processing is at the heart of the approach.",
    "A NANDA SÁ está presente no Senegal e na Guiné-Bissau. Os cuidados são fabricados pelas nossas equipas, com ingredientes colhidos na África Ocidental junto de cooperativas parceiras. A transformação local está no centro da abordagem."
   ) },
   { type: "h2", id: "ou-decouvrir", text: l("Où découvrir la collection", "Where to discover the collection", "Onde descobrir a colecção") },
   { type: "p", text: l(
    "La collection est présentée en détail sur la page Cosmétiques. Les commandes B2B, hôtels, spas et revendeurs se font via le formulaire de contact, avec des conditions dédiées et du co-branding sur demande.",
    "The collection is presented in detail on the Cosmetics page. B2B, hotel, spa and reseller orders are placed via the contact form, with dedicated conditions and co-branding on request.",
    "A colecção é apresentada em detalhe na página Cosméticos. As encomendas B2B, hotéis, spas e revendedores fazem-se via o formulário de contacto, com condições dedicadas e co-branding a pedido."
   ) },
  ],
  cta: { label: l("Découvrir la collection", "Discover the collection", "Descobrir a colecção"), to: "/cosmetiques" },
 },
 {
  slug: "arrivee-nanda-sa",
  date: "2026-01-08",
  type: l("Nouveauté", "New arrival", "Novidade"),
  univers: "terroirs",
  universLabel: l("Produits & Terroirs", "Products & Terroirs", "Produtos & Terroirs"),
  title: l(
   "NANDA SÁ. Fleur de Sel & Miel du Sénégal",
   "NANDA SÁ. Fleur de Sel & Honey from Senegal",
   "NANDA SÁ. Flor de Sal & Mel do Senegal"
  ),
  excerpt: l(
   "Deux signatures emblématiques du Sénégal rejoignent notre catalogue.",
   "Two emblematic signatures from Senegal join our catalogue.",
   "Duas assinaturas emblemáticas do Senegal juntam-se ao nosso catálogo."
  ),
  cover: "/photos/nanda-sa-food/flor-sal-mel-nanda.jpg",
  coverAlt: l(
   "Fleur de sel et miel du Sénégal, produits NANDA SÁ",
   "Fleur de sel and honey from Senegal, NANDA SÁ products",
   "Flor de sal e mel do Senegal, produtos NANDA SÁ"
  ),
  seo: {
   title: l(
    "Fleur de sel & miel du Sénégal au catalogue NANDA SÁ | Actualités",
    "Senegal fleur de sel & honey join the NANDA SÁ catalogue | News",
    "Flor de sal & mel do Senegal no catálogo NANDA SÁ | Actualidades"
   ),
   description: l(
    "La fleur de sel d'Adéane et le miel du Sénégal rejoignent le catalogue Produits & Terroirs de NANDA SÁ. Deux produits récoltés avec soin au Sénégal.",
    "Adéane fleur de sel and Senegal honey join the NANDA SÁ Products & Terroirs catalogue. Two products carefully harvested in Senegal.",
    "A flor de sal de Adéane e o mel do Senegal juntam-se ao catálogo Produtos & Terroirs da NANDA SÁ. Dois produtos colhidos com cuidado no Senegal."
   ),
   keywords: "fleur de sel, Adéane, miel du Sénégal, Casamance, Ziguinchor, NANDA SÁ, terroir",
  },
  intro: l(
   "Deux produits du terroir sénégalais rejoignent le catalogue NANDA SÁ : la fleur de sel d'Adéane et le miel du Sénégal. Deux produits simples, choisis avec la même exigence de qualité et de traçabilité.",
   "Two Senegalese terroir products join the NANDA SÁ catalogue: Adéane fleur de sel and Senegal honey. Two simple products, chosen with the same standard of quality and traceability.",
   "Dois produtos do terroir senegalês juntam-se ao catálogo NANDA SÁ: a flor de sal de Adéane e o mel do Senegal. Dois produtos simples, escolhidos com a mesma exigência de qualidade e rastreabilidade."
  ),
  sections: [
   { type: "h2", id: "fleur-de-sel-adeane", text: l("La fleur de sel d'Adéane", "Adéane fleur de sel", "A flor de sal de Adéane") },
   { type: "p", text: l(
    "La fleur de sel est prélevée à la main à la surface des salines d'Adéane, en Casamance, puis séchée au soleil. Un geste patient, hérité des sauniers de la région de Ziguinchor, pour des cristaux délicats.",
    "Fleur de sel is skimmed by hand from the surface of the Adéane salt pans, in Casamance, then sun-dried. A patient gesture, inherited from the salt workers of the Ziguinchor region, for delicate crystals.",
    "A flor de sal é recolhida à mão à superfície das salinas de Adéane, na Casamansa, e depois seca ao sol. Um gesto paciente, herdado dos salineiros da região de Ziguinchor, para cristais delicados."
   ) },
   { type: "h2", id: "miel-du-senegal", text: l("Le miel du Sénégal", "Senegal honey", "O mel do Senegal") },
   { type: "p", text: l(
    "Le miel est récolté au Sénégal, entre mangrove et forêt, auprès d'apiculteurs partenaires. Il est filtré avec soin, sans transformation inutile, avec une traçabilité par récolte.",
    "The honey is harvested in Senegal, between mangrove and forest, with partner beekeepers. It is carefully filtered, without unnecessary processing, with traceability by harvest.",
    "O mel é colhido no Senegal, entre o mangal e a floresta, junto de apicultores parceiros. É filtrado com cuidado, sem transformação desnecessária, com rastreabilidade por colheita."
   ) },
   { type: "h2", id: "disponibilite", text: l("Disponibilité", "Availability", "Disponibilidade") },
   { type: "p", text: l(
    "Les deux produits sont présentés sur la page Produits & Terroirs. Pour toute commande ou question, le formulaire de contact est à disposition.",
    "Both products are presented on the Products & Terroirs page. For any order or question, the contact form is available.",
    "Os dois produtos são apresentados na página Produtos & Terroirs. Para qualquer encomenda ou questão, o formulário de contacto está disponível."
   ) },
  ],
  cta: { label: l("Découvrir les Terroirs", "Discover the Terroirs", "Descobrir os Terroirs"), to: "/terroirs" },
 },
 {
  slug: "huile-palme-cacheu",
  date: "2025-12-15",
  type: l("Nouveauté", "New arrival", "Novidade"),
  univers: "terroirs",
  universLabel: l("Produits & Terroirs", "Products & Terroirs", "Produtos & Terroirs"),
  title: l(
   "Huile de Palme Rouge artisanale de Cacheu",
   "Artisanal Red Palm Oil from Cacheu",
   "Óleo de Palma Vermelho artesanal de Cacheu"
  ),
  excerpt: l(
   "Une extraction traditionnelle en Guinée-Bissau, désormais disponible.",
   "A traditional extraction from Guinea-Bissau, now available.",
   "Uma extracção tradicional da Guiné-Bissau, agora disponível."
  ),
  cover:
   "https://customer-assets.emergentagent.com/job_nanda-sa-hub/artifacts/8h1p67p9_C0B99994-90F8-4411-BA8F-1F45E4CF549B.png",
  coverAlt: l(
   "Huile de palme rouge artisanale de Cacheu, Guinée-Bissau",
   "Artisanal red palm oil from Cacheu, Guinea-Bissau",
   "Óleo de palma vermelho artesanal de Cacheu, Guiné-Bissau"
  ),
  seo: {
   title: l(
    "Huile de palme rouge artisanale de Cacheu | NANDA SÁ Actualités",
    "Artisanal red palm oil from Cacheu | NANDA SÁ News",
    "Óleo de palma vermelho artesanal de Cacheu | NANDA SÁ Actualidades"
   ),
   description: l(
    "L'huile de palme rouge artisanale de la région de Cacheu, en Guinée-Bissau, rejoint les produits présentés par NANDA SÁ. Extraction traditionnelle, savoir-faire villageois.",
    "Artisanal red palm oil from the Cacheu region, in Guinea-Bissau, joins the products presented by NANDA SÁ. Traditional extraction, village know-how.",
    "O óleo de palma vermelho artesanal da região de Cacheu, na Guiné-Bissau, junta-se aos produtos apresentados pela NANDA SÁ. Extracção tradicional, saber-fazer de aldeia."
   ),
   keywords: "huile de palme rouge, Cacheu, Guinée-Bissau, extraction artisanale, NANDA SÁ",
  },
  intro: l(
   "L'huile de palme rouge artisanale de la région de Cacheu, en Guinée-Bissau, rejoint les produits présentés par NANDA SÁ. Une huile issue d'une extraction traditionnelle, très éloignée des modèles industriels.",
   "Artisanal red palm oil from the Cacheu region, in Guinea-Bissau, joins the products presented by NANDA SÁ. An oil from traditional extraction, far removed from industrial models.",
   "O óleo de palma vermelho artesanal da região de Cacheu, na Guiné-Bissau, junta-se aos produtos apresentados pela NANDA SÁ. Um óleo de extracção tradicional, muito afastado dos modelos industriais."
  ),
  sections: [
   { type: "h2", id: "extraction-traditionnelle", text: l("Une extraction traditionnelle", "A traditional extraction", "Uma extracção tradicional") },
   { type: "p", text: l(
    "Dans les villages de la région de Cacheu, les régimes de palme sont récoltés puis transformés à l'atelier : fermentation brève, dépulpage, cuisson et pressage à chaud. Un procédé manuel, patient, qui donne une huile rouge dense, au goût marqué.",
    "In the villages of the Cacheu region, palm bunches are harvested then processed at the workshop: brief fermentation, depulping, boiling and hot pressing. A manual, patient process that gives a dense red oil with a distinctive taste.",
    "Nas aldeias da região de Cacheu, os cachos de palma são colhidos e depois transformados na oficina: fermentação breve, despolpação, cozedura e prensagem a quente. Um processo manual, paciente, que dá um óleo vermelho denso, de sabor marcado."
   ) },
   { type: "h2", id: "savoir-faire-feminin", text: l("Un savoir-faire porté par les femmes", "A know-how carried by women", "Um saber-fazer levado pelas mulheres") },
   { type: "p", text: l(
    "Cette extraction repose sur un savoir-faire transmis de mère en fille. Le Carnet NANDA lui consacre un récit complet, à lire pour comprendre la filière et celles qui la font vivre.",
    "This extraction rests on a know-how passed down from mother to daughter. The NANDA Journal devotes a full story to it, to understand the sector and the women who keep it alive.",
    "Esta extracção assenta num saber-fazer transmitido de mãe para filha. O Caderno NANDA dedica-lhe um relato completo, para compreender a fileira e quem a faz viver."
   ) },
  ],
  cta: { label: l("Lire le récit dans le Carnet", "Read the story in the Journal", "Ler o relato no Caderno"), to: "/carnet/savoir-faire-huile-palme-rouge" },
 },
 {
  // BROUILLON : fait confirmé par la direction, date à confirmer avant publication.
  slug: "arrivage-materiel-frigorifique-pro",
  hidden: true,
  date: null,
  type: l("Opérations", "Operations", "Operações"),
  univers: "pro",
  universLabel: l("NANDA SÁ PRO", "NANDA SÁ PRO", "NANDA SÁ PRO"),
  title: l(
   "NANDA SÁ PRO : réception d'un arrivage de matériel frigorifique",
   "NANDA SÁ PRO: reception of a refrigeration equipment shipment",
   "NANDA SÁ PRO: recepção de uma chegada de material frigorífico"
  ),
  excerpt: l(
   "Palettes réceptionnées, évaporateurs, groupes extérieurs et réseaux : les équipes PRO préparent les prochaines installations de froid professionnel.",
   "Pallets received, evaporators, outdoor units and piping: the PRO teams are preparing the next professional refrigeration installations.",
   "Paletes recebidas, evaporadores, grupos exteriores e redes: as equipas PRO preparam as próximas instalações de frio profissional."
  ),
  cover: "/photos/realisations/refrigeration-01-reception-palettes.webp",
  coverAlt: l(
   "Réception de palettes de matériel frigorifique NANDA SÁ PRO",
   "Reception of refrigeration equipment pallets, NANDA SÁ PRO",
   "Recepção de paletes de material frigorífico NANDA SÁ PRO"
  ),
  seo: {
   title: l(
    "Arrivage de matériel frigorifique NANDA SÁ PRO | Actualités",
    "NANDA SÁ PRO refrigeration equipment shipment | News",
    "Chegada de material frigorífico NANDA SÁ PRO | Actualidades"
   ),
   description: l(
    "NANDA SÁ PRO réceptionne un arrivage de matériel frigorifique professionnel : évaporateurs, groupes extérieurs, réseaux de tuyauterie. Activité de l'univers froid et réfrigération.",
    "NANDA SÁ PRO receives a shipment of professional refrigeration equipment: evaporators, outdoor units, piping. Activity of the refrigeration and cold universe.",
    "A NANDA SÁ PRO recebe uma chegada de material frigorífico profissional: evaporadores, grupos exteriores, redes de tubagem. Actividade do universo de frio e refrigeração."
   ),
   keywords: "NANDA SÁ PRO, réfrigération, froid professionnel, chambre froide, arrivage, Guinée-Bissau, Sénégal",
  },
  intro: l(
   "Les équipes de NANDA SÁ PRO ont réceptionné un arrivage de matériel destiné aux installations de froid professionnel. Réception, contrôle, préparation : retour sur une étape logistique qui précède chaque chantier.",
   "The NANDA SÁ PRO teams received a shipment of equipment intended for professional refrigeration installations. Reception, checking, preparation: a look back at a logistics step that precedes each project.",
   "As equipas da NANDA SÁ PRO receberam uma chegada de material destinado às instalações de frio profissional. Recepção, controlo, preparação: um olhar sobre uma etapa logística que precede cada obra."
  ),
  sections: [
   { type: "h2", id: "reception-controle", text: l("Réception et contrôle", "Reception and checking", "Recepção e controlo") },
   { type: "p", text: l(
    "Chaque arrivage commence par une réception organisée : déchargement des palettes, vérification des équipements, tri et préparation avant installation. Cette rigueur en amont conditionne la qualité des chantiers qui suivent.",
    "Each shipment begins with an organised reception: unloading the pallets, checking the equipment, sorting and preparing before installation. This upstream rigour conditions the quality of the projects that follow.",
    "Cada chegada começa com uma recepção organizada: descarga das paletes, verificação dos equipamentos, triagem e preparação antes da instalação. Este rigor a montante condiciona a qualidade das obras que se seguem."
   ) },
   { type: "h2", id: "materiel-froid", text: l("Du matériel pour le froid professionnel", "Equipment for professional refrigeration", "Material para o frio profissional") },
   { type: "p", text: l(
    "L'arrivage comprend les équipements qui composent une installation frigorifique : évaporateurs de chambre froide, groupes extérieurs et réseaux de tuyauterie. NANDA SÁ PRO assure le diagnostic, le dimensionnement, la fourniture des équipements et l'installation, du premier relevé à la mise en service.",
    "The shipment includes the equipment that makes up a refrigeration installation: cold room evaporators, outdoor units and piping. NANDA SÁ PRO handles assessment, sizing, equipment supply and installation, from the first survey to commissioning.",
    "A chegada inclui os equipamentos que compõem uma instalação frigorífica: evaporadores de câmara fria, grupos exteriores e redes de tubagem. A NANDA SÁ PRO assegura o diagnóstico, o dimensionamento, o fornecimento dos equipamentos e a instalação, do primeiro levantamento à entrada em serviço."
   ) },
  ],
  gallery: [
   { src: "/photos/realisations/refrigeration-02-chambre-froide-evaporateurs.webp", alt: l("Évaporateurs de chambre froide en cours de pose", "Cold room evaporators being fitted", "Evaporadores de câmara fria em instalação") },
   { src: "/photos/realisations/refrigeration-03-groupes-exterieurs-raccordement.webp", alt: l("Raccordement de groupes extérieurs frigorifiques", "Connection of outdoor refrigeration units", "Ligação de grupos exteriores frigoríficos") },
   { src: "/photos/realisations/refrigeration-05-reseaux-tuyauterie.webp", alt: l("Réseaux de tuyauterie frigorifique", "Refrigeration piping networks", "Redes de tubagem frigorífica") },
  ],
  cta: { label: l("Découvrir nos solutions PRO", "Discover our PRO solutions", "Descobrir as nossas soluções PRO"), to: "/marques/energia-pro" },
 },
];
